var __jsx = React.createElement;
import { cn } from '@lib/cn';
import React from 'react';
const TextWithLinks = _ref => {
  let {
    text,
    linksActions = [],
    textStyle = '',
    linksStyle = 'text-primary-main',
    boldStyle = ''
  } = _ref;
  const renderText = () => {
    // First, handle bold text by replacing **text** with a placeholder
    let processedText = text;
    const boldPlaceholders = [];
    let boldIndex = 0;
    processedText = processedText.replace(/\*\*(.*?)\*\*/g, (match, content) => {
      const placeholder = "__BOLD_".concat(boldIndex, "__");
      boldPlaceholders.push(content);
      boldIndex++;
      return placeholder;
    });

    // Regular expression to match links marked with @L/
    const linkRegex = /@L(\/.*?\/)/g;

    // Split the text based on the links
    const textParts = processedText.split(linkRegex);
    let linkIndex = 0;

    // Iterate through the text parts and create elements
    const renderedText = textParts.map((part, index) => {
      if (part.startsWith('/') && part.endsWith('/')) {
        // This is a link part
        const linkText = part.replaceAll('/', '');
        const link = __jsx("span", {
          key: "text-link-".concat(index),
          className: cn("text-confirmation-code_text_color tx-pmd-semiBold link", linksStyle),
          onClick: linksActions[linkIndex] ? linksActions[linkIndex] : () => {}
        }, linkText);
        linkIndex++;
        return link;
      } else {
        // This is regular text, check for bold placeholders
        const parts = part.split(/(__BOLD_\d+__)/g);
        return parts.map((textPart, partIndex) => {
          const boldMatch = textPart.match(/__BOLD_(\d+)__/);
          if (boldMatch) {
            const boldContentIndex = parseInt(boldMatch[1]);
            return __jsx("strong", {
              key: "text-bold-".concat(index, "-").concat(partIndex),
              className: boldStyle
            }, boldPlaceholders[boldContentIndex]);
          } else {
            return __jsx("span", {
              key: "text-regular-".concat(index, "-").concat(partIndex)
            }, textPart);
          }
        });
      }
    });
    return renderedText.flat();
  };
  return __jsx("p", {
    className: textStyle
  }, renderText());
};
export default TextWithLinks;